import React from 'react'
import MapMedicine from '../Components/MapMedicine/MapMedicine'

const MapMedicineView = () => {
  return (
    <div>
        <MapMedicine />
    </div>
  )
}

export default MapMedicineView